import React, { useMemo } from 'react'
import styles from './styles.module.css'

function SearchResultVersionTitle({ version }) {
  const isStartVersion = useMemo(() => version === 'start', [version])

  return version && !isStartVersion && <span className={styles.searchResultVersion}>{version}</span>
}

export default SearchResultVersionTitle
